import { render, staticRenderFns } from "./jim-barry-wines.vue?vue&type=template&id=9c6d7ecc&scoped=true"
import script from "./jim-barry-wines.vue?vue&type=script&lang=js"
export * from "./jim-barry-wines.vue?vue&type=script&lang=js"
import style0 from "./jim-barry-wines.vue?vue&type=style&index=0&id=9c6d7ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6d7ecc",
  null
  
)

export default component.exports